<template>
  <router-view />
</template>

<script>
import storeMixin, {
  unRegisterMixin,
} from '@quisit/mipe-utils/mixins/storeGenerator';
const STORE_MODULE_NAME = 'HelpDeskModule';

export default {
  name: 'HelpDeskWrapper',
  mixins: [unRegisterMixin, storeMixin],
  data: () => ({
    moduleName: STORE_MODULE_NAME,
  }),
};
</script>
